"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE_LAUNCH_MAX_ADS = void 0;
/**
 * Most tested ads one manual scale launch takes. A Meta ad set holds at most
 * 50 ads and a TikTok target fewer, so a larger request could never fit one
 * target. The launch procedures' input enforces it; the launch screens check
 * it first so the user gets a plain message instead of a validation error.
 */
exports.SCALE_LAUNCH_MAX_ADS = 50;
